import { Grid } from '@mui/material';

import CountWithTextCard from '../../components/countWithTextCard/CountWithTextCard';

export interface ICVParserRecord {
  count: string;
  hour: string;
  type: string;
  titleText: string;
}
const CVParsedRecord = ({ count, hour, type, titleText = 'Parsed' }: ICVParserRecord) => (
  <Grid item xs={12} style={{ height: '100%' }}>
    <CountWithTextCard
      count={count}
      text={`${titleText} In Last ${hour} ${type == 'h' ? 'Hours' : 'Days'}`}
      fullHeight={true}
    />
  </Grid>
);

export default CVParsedRecord;
